import { connect } from 'react-redux';

import { fetchPublicationYears } from 'client/ducks/publications/actions';
import { getPublicationYears, isLoadingYears } from 'client/ducks/publications/selectors';
import { State } from 'client/store';

import PublicationsYearFilter, { DispatchProps, StateProps } from './publications-year-filter';

function mapStateToProps(state: State): StateProps {
    return {
        years: getPublicationYears(state),
        isLoadingYears: isLoadingYears(state)
    };
}

const mapDispatchToProps = { fetchPublicationYears };

const component = connect<StateProps, DispatchProps>(
    mapStateToProps,
    mapDispatchToProps
)(PublicationsYearFilter) as any;

export default component;
